export { default as Logo } from './logo'
export { IconFacebook } from './facebook'
export { IconFacebookF } from './facebookF'
export { IconInstagram } from './instagram'
export { IconLinkedin } from './linkedin'
export { IconTiktok } from './tiktok'
export { IconYoutube } from './youtube'
export { IconNotFound } from './notFound'
export { IconEmptyVacancies } from './empty-vacancies'
export { IconGlassdoor } from './glassdoor'
export { IconProfilerGroup } from './profiler-group'
export { default as LogoWhatsapp } from './whatsapp'
